<template>
  <div class="modal-register-cdb">
    <div class="content-register-cdb" v-if="step === 0">
      <span class="material-symbols-outlined close-icon-small-register" @click="closeModalRegister()">close</span>
      <div class="header-register-cdb">
        <h2 class="title-register-cdb">RESPONSÁVEL PELO CIRCO</h2>
        <h4 class="name-register-cdb">{{ name }}</h4>
      </div>
      <div class="form-register-cdb">
        <input type="text" class="form-register-input" v-model="formRegister.name" placeholder="Digite seu nome">
        <input type="text" class="form-register-input" v-model="formRegister.email" placeholder="Digite seu e-mail">
        <input type="text" class="form-register-input" v-model="formRegister.phone" placeholder="Digite seu celular">
        <input type="password" class="form-register-input" v-model="formRegister.phone" placeholder="Celular">
      </div>
      <div class="send-info-register">
        <button class="btn-send-register" @click="nextStep()">Enviar</button>
        <button class="btn-register-cdb" @click="registerModal()">Registrar</button>
      </div>
    </div>
    <div class="content-localization-cdb" v-if="step === 1">
      <span class="material-symbols-outlined close-icon-small-register" @click="closeModalRegister()">close</span>
      <div class="header-localization-cdb">
        <h2 class="title-localization-cdb">NOVA LOCALIZAÇÃO</h2>
        <h4 class="name-localization-cdb">{{ name }}</h4>
      </div>
      <div class="form-localization-cdb">
        <div class="state-and-city-localization">
          <v-select
            class="input-state-localization-cdb"
            :options="optionsStates"
            label="uf"
            placeholder="UF"
            :reduce="name => name.uf"
            v-model="formLocalization.state"
            @input="setState(formLocalization.state)"
          >
          </v-select>
          <v-select
            class="input-city-localization-cdb"
            :options="optionsCitys"
            :disabled="!showInputCity"
            label="city"
            placeholder="Cidade"
            :reduce="name => name.city"
            v-model="formLocalization.city"
          >
          </v-select>
        </div>
        <input type="text" class="form-licalization-input" v-model="formLocalization.address" placeholder="Localização">
        <div class="period-localization">
          <p class="title-period">Periodo:</p>
          <input type="text" class="form-period-input" v-model="formLocalization.period.initial" placeholder="De">
          <input type="text" class="form-period-input" v-model="formLocalization.period.final" placeholder="Até">
        </div>
      </div>
      <div class="send-info-localization">
        <button class="btn-send-localization" @click="sendInfos()">Enviar</button>
        <button class="btn-localization-cdb" @click="updateInfo()">Atualizar outras informações</button>
      </div>
    </div>
    <div class="content-others-cdb" v-if="step === 2">
      <span class="material-symbols-outlined close-icon-small-register" @click="closeModalRegister()">close</span>
      <div class="header-others-cdb">
        <h2 class="title-others-cdb">OUTRAS INFORMAÇÕES A SEREM ATUALIZADAS</h2>
        <h4 class="name-others-cdb">{{ name }}</h4>
      </div>
      <div class="form-others-cdb">
        <input type="text" class="form-others-input" v-model="othersInfos.name" placeholder="Digite seu nome">
        <input type="text" class="form-others-input" v-model="othersInfos.phone" placeholder="Digite seu celular">
        <input type="text" class="form-others-input" v-model="othersInfos.email" placeholder="Digite seu e-mail">
        <input type="text" class="form-others-input" v-model="othersInfos.facebook" placeholder="Facebook">
        <input type="text" class="form-others-input" v-model="othersInfos.instagram" placeholder="Instagram">
        <input type="text" class="form-others-input" v-model="othersInfos.other" placeholder="Outro">
      </div>
      <div class="send-info-others">
        <button class="btn-send-others" @click="sendOthersInfos()">Enviar</button>
        <p class="title-suport">Falar com o suporte: 11 99999-1234</p>
      </div>
    </div>
  </div>
</template>

<script>
import { VueSelect } from "vue-select"
import { cdbService } from "@/components/common/services/cdb_service"

export default {
  name: 'ModalRegisterCdb',
  components: {
    VueSelect
  },
  props: ['name'],
  data () {
    return {
      step: 0,
      showModal: false,
      nameCirco: '',
      optionsStates: [],
      stateSelected: null,
      optionsCitys: [],
      citySelected: null,
      showInputCity: false,
      formRegister: {
        name: '',
        email: '',
        phone: '',
        password: ''
      },
      formLocalization: {
        state: '',
        city: '',
        address: '',
        period: {
          initial: '',
          final: ''
        }
      },
      othersInfos: {
        name: '',
        phone: '',
        email: '',
        facebook: '',
        instagram: '',
        other: ''
      }
    }
  },
  async mounted () {
    const states = await cdbService.getState()

    this.optionsStates = states.map(state => { return { uf: state.sigla, name: state.nome } })
    this.optionsStates.sort((a, b) => {
      if(a.uf < b.uf) { return -1 }
      if(a.uf > b.uf) { return 1 }
    return 0
    })

  },
  computed: {

  },
  methods: {
    async setState (uf) {
      const citys = await cdbService.getCity(uf)
      this.optionsCitys = citys.map(c => { return { city: c.nome } })
      this.optionsCitys.length > 0 ? this.showInputCity = true : false
    },
    registerModal () {
      window.open('https://circosdobrasil.com/loginandshopping/cardafter')
      this.$root.$emit('close-modal-register')
    },
    nextStep () {
      this.step++
    },
    sendInfos () {
      this.$root.$emit('close-modal-register')
      this.step = 0
    },
    updateInfo () {
      this.step++
    },
    sendOthersInfos () {
      this.$root.$emit('close-modal-register')
      this.step = 0
    },
    closeModalRegister () {
      this.$root.$emit('close-modal-register')
    }
  }
}
</script>

<style lang="scss">
.modal-register-cdb {
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00000075;
  .content-register-cdb {
    position: relative;
    z-index: 10;
    border-top: 10px solid #BF3D26;
    width: 30%;
    height: 50%;
    background: #FAF5E4;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header-register-cdb {
      width: 100%;
      height: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .title-register-cdb {
        font-size: 1.8em;
      }
      .name-register-cdb {
        width: 90%;
        text-align: center;
        font-size: 1.6em;
        background: #BF3D26;
        color: #FFFFFF;
        border-radius: 35px;
        padding: 0 10px !important;
      }
    }
    .form-register-cdb {
      width: 90%;
      height: 60%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .form-register-input {
        width: 100%;
        height: 40px;
        padding-left: 10px !important;
        outline: none;
        border-radius: 35px;
        border: 1px solid #BF3D26;
      }
    }
    .send-info-register {
      width: 90%;
      height: 20%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .btn-send-register, .btn-register-cdb {
        width: 200px;
        height: 35px;
        border: none;
        border-radius: 35px;
        font-size: 18px;
        font-weight: bold;
        background: #BF3D26;
        cursor: pointer;
        color: #FFFFFF;
      }
    }
  }
  .content-localization-cdb {
    position: relative;
    z-index: 10;
    border-top: 10px solid #BF3D26;
    width: 30%;
    height: 50%;
    background: #FAF5E4;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header-localization-cdb {
      width: 100%;
      height: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .title-localization-cdb {
        font-size: 1.8em;
      }
      .name-localization-cdb {
        width: 90%;
        text-align: center;
        font-size: 1.6em;
        background: #BF3D26;
        color: #FFFFFF;
        border-radius: 35px;
        padding: 0 10px !important;
      }
    }
    .form-localization-cdb {
      width: 90%;
      height: 60%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      .state-and-city-localization {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .vs__dropdown-toggle {
          height: 40px;
          border-radius: 35px;
          border: 1px solid #BF3D26;
          .vs__selected-options {
            padding-left: 10px !important;
          }
          .vs__actions {
            padding-right: 10px !important;
            .vs__clear {
              display: none;
            }
          }
        }
        .input-state-localization-cdb {
          width: 150px;
        }
        .input-city-localization-cdb {
          width: 360px;
        }
      }
      .form-licalization-input {
        width: 100%;
        height: 40px;
        padding-left: 10px !important;
        outline: none;
        border-radius: 35px;
        border: 1px solid #BF3D26; 
      }
      .period-localization {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-period {
          font-size: 20px;
          font-weight: bold;
        }
        .form-period-input {
          width: 200px;
          height: 40px;
          border-radius: 35px;
          outline: none;
          border: 1px solid #BF3D26;
          padding-left: 10px !important;
        }
      }
    }
    .send-info-localization {
      width: 90%;
      height: 20%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .btn-send-localization, .btn-localization-cdb {
        width: 200px;
        height: 35px;
        border: none;
        border-radius: 35px;
        font-size: 18px;
        font-weight: bold;
        background: #BF3D26;
        cursor: pointer;
        color: #FFFFFF;
      }
      .btn-localization-cdb {
        width: 280px;
      }
    }
  }
  .content-others-cdb {
    position: relative;
    z-index: 10;
    border-top: 10px solid #BF3D26;
    width: 30%;
    height: 50%;
    background: #FAF5E4;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header-others-cdb {
      width: 100%;
      height: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .title-others-cdb {
        font-size: 1.5em;
      }
      .name-others-cdb {
        width: 90%;
        text-align: center;
        font-size: 1.6em;
        background: #BF3D26;
        color: #FFFFFF;
        border-radius: 35px;
        padding: 0 10px !important;
      }
    }
    .form-others-cdb {
      width: 90%;
      height: 60%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .form-others-input {
        width: 100%;
        height: 40px;
        padding-left: 10px !important;
        outline: none;
        border-radius: 35px;
        border: 1px solid #BF3D26;
      }
    }
    .send-info-others {
      width: 90%;
      height: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      .btn-send-others {
        width: 200px;
        height: 35px;
        border: none;
        border-radius: 35px;
        font-size: 18px;
        font-weight: bold;
        background: #BF3D26;
        cursor: pointer;
        color: #FFFFFF;
      }
      .title-suport {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .close-icon-small-register {
    position: absolute;
    top: 3px;
    right: 3px;
    border: none;
    background: #BF3D26;
    color: #FFFFFF;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
@media only screen and (max-width: 500px) {
}
</style>